module.exports = __webpack_public_path__ + "static/media/thumbnail.4f81d065.jpg";